<!-- Strategy mapping -->
<div *ngIf="hasTitle" class="block-title"
[translatable]="{
  transKey: 'committeeDetails.strategyMapping',
  modEnum: translationModulesEnum?.committeeDetails
}">
    {{ "committeeDetails.strategyMapping" | translate }}
  </div>
  <table *ngIf="list?.length > 0">
    <tr *ngFor="let item of list">
      <!-- goal title -->
      <td>
        <label [for]="item.id">
          <span [class.disabled]="
                item?.children?.length === 0 && item?.goalType?.name !== 'KPI'
              " [class]="'badge ' + item.goalType?.name?.toLowerCase()">
            <i class="bx bx-check"></i>
            {{
            language == "en" ? item?.goalType?.name : item?.goalType?.arabicName
            }}
          </span>
        </label>
      </td>
      <!-- kpi -->
      <td>
        <span class="name">
          {{ language == "en" ? item?.title : item?.titleAr }}
        </span>
      </td>
    </tr>
  </table>